/** A slow refresh must never restore a cart the customer has since changed. */
export const refreshCartIfCurrent = async <State, Result>({
  initialState,
  getCurrentState,
  refresh,
  apply,
}: {
  initialState: State
  getCurrentState: () => State
  refresh: () => Promise<Result>
  apply: (result: Result) => void
}): Promise<boolean> => {
  if (getCurrentState() !== initialState) return false
  const result = await refresh()
  if (getCurrentState() !== initialState) return false
  apply(result)
  return true
}
